(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["why-us"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll('.feature-item');

    items.forEach((item) => {
      const splitElement = item.querySelector('.split');
      if (!splitElement || splitElement.dataset.split === 'true') return;

      const imageBlock = item.querySelector('.image-block');
      const image = imageBlock ? imageBlock.querySelector('img') : null;
      const textBlock = item.querySelector('.feature-text-block');
      const text = splitElement.textContent.trim();

      if (!text) return;

      const chars = text.split('');
      const charsTotal = chars.length;

      // Initialize after image loads to get proper dimensions
      const initCurvedText = () => {
        // Get image dimensions
        let containerWidth = 200;
        let containerHeight = 200;

        if (imageBlock) {
          const rect = imageBlock.getBoundingClientRect();
          containerWidth = rect.width || imageBlock.offsetWidth || 200;
          containerHeight = rect.height || imageBlock.offsetHeight || 200;

          // Match feature-text-block size and position to image-block
          if (textBlock) {
            const topOffset = imageBlock.offsetTop || 0;
            const leftOffset = imageBlock.offsetLeft || 0;

            textBlock.style.width = `${containerWidth}px`;
            textBlock.style.height = `${containerHeight}px`;
            textBlock.style.top = `${topOffset}px`;
            textBlock.style.left = `${leftOffset}px`;
          }
        }

        // Set total for offset-distance calculation
        splitElement.style.setProperty('--total', charsTotal);

        // Clear and rebuild
        splitElement.innerHTML = '';
        splitElement.setAttribute('aria-label', text);
        splitElement.dataset.split = 'true';

        chars.forEach((item, index) => {
          const c = document.createElement('span');
          const letter = document.createTextNode(item);
          c.appendChild(letter);
          splitElement.append(c);

          c.style.setProperty('--i', index);

          if (splitElement.getAttribute('aria-label')) {
            c.setAttribute('aria-hidden', 'true');
          }
        });
      };

      // Wait for image to load
      if (image && !image.complete) {
        image.addEventListener('load', () => {
          requestAnimationFrame(() => {
            setTimeout(initCurvedText, 50);
          });
        });
        image.addEventListener('error', () => {
          requestAnimationFrame(() => {
            setTimeout(initCurvedText, 50);
          });
        });
      } else {
        requestAnimationFrame(() => {
          setTimeout(initCurvedText, 100);
        });
      }
    });

    // Intersection Observer for scroll trigger
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!entry.target.classList.contains('is-visible')) {
              entry.target.classList.add('is-visible');
              console.log('Animation triggered for:', entry.target);
              // Stop observing once animation is triggered
              observer.unobserve(entry.target);
            }
          }
        });
      },
      { 
        threshold: 0.65,
        rootMargin: '0px'
      }
    );

    items.forEach((item) => {
      observer.observe(item);
      console.log('Observing item:', item);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
